import { useEffect } from 'react';

import { metricsApi } from '@/lib/api';
import { sendPwaTelemetryIfDue } from '@/lib/pwa';
import { useAuthStore } from '@/stores/authStore';

/**
 * Collecte + envoie la télémétrie plateforme PWA au boot (ADR 0007 D2 —
 * Métriques A/B du cap natif), UNIQUEMENT si un user est connecté. Appelé
 * une fois dans App.tsx, comme `useOnlineStatusListener` (même idiome).
 *
 * Le throttle 24h et l'échec silencieux vivent dans `sendPwaTelemetryIfDue`
 * (lib/pwa.ts) — ce hook ne fait qu'y brancher l'état d'auth et le
 * transport HTTP réel (`metricsApi.sendPwaTelemetry`).
 */
export function usePwaTelemetryBoot(): void {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());

  useEffect(() => {
    if (!isAuthenticated) return;
    void sendPwaTelemetryIfDue((payload) => metricsApi.sendPwaTelemetry(payload));
  }, [isAuthenticated]);
}
